module.exports = __webpack_public_path__ + "static/media/users.2951b49d.png";